import { render } from "./PD.vue?vue&type=template&id=f6a2b856&scoped=true"
import script from "./PD.vue?vue&type=script&lang=js"
export * from "./PD.vue?vue&type=script&lang=js"

import "./PD.vue?vue&type=style&index=0&id=f6a2b856&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6a2b856"]])

export default __exports__